module.exports = __webpack_public_path__ + "assets/img/img-detail-sp.8b176357.jpg";